module.exports = __webpack_public_path__ + "180696745dcb2b393125ae0b02e41a39.pdf";